var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1440px",
    height: "1024px",
    viewBox: "0 0 1440 1024",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "background") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.25
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "#FF7711",
    points: "-83 399 573 399 601.875 168 -54.125 168"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "#FF7711",
    points: "942 570 1598 570 1626.875 339 970.875 339"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "#FF7711",
    points: "277 610 1160.18615 610 1199.06115 299 315.875 299"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "#FF7711",
    points: "411 710 1294.18615 710 1333.06115 399 449.875 399"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "#FF7711",
    points: "-392 964 491.186147 964 530.061147 653 -353.125 653"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "#FF7711",
    points: "-268 751 774 751 807.125 486 -234.875 486"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "#FF7711",
    points: "602 797 1605 797 1619.625 680 616.625 680"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "#FF7711",
    points: "209 359 1251 359 1284.125 94 242.125 94"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "#FF7711",
    points: "488 1157 1530 1157 1563.125 892 521.125 892"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "#FF7711",
    points: "-355 1086 687 1086 720.125 821 -321.875 821"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "#FF7711",
    points: "762 204 1786.25 204 1806 46 781.75 46"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "#FF7711",
    points: "-475 125 549.25 125 569 -33 -455.25 -33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.73f32232790ff0dfddfb4eea50268bd7.svg";
export { ForwardRef as ReactComponent };